var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { regionClearData } from "../../../store/region/actions";
import { useGetRegions } from "./callApis/callApiRegions";
var EMPTY_OPTION = { id: "-1", value: "-1", name: " " };
var level1 = "REGION_LEVEL1";
var level2 = "REGION_LEVEL2";
var level3 = "REGION_LEVEL3";
export var useRegionCascade = function (_a) {
    var addressData = _a.addressData;
    var dispatch = useDispatch();
    var _b = useState(false), triggerRegion = _b[0], setTriggerRegion = _b[1];
    var _c = useState("REGION_LEVEL1"), typeRegion = _c[0], setTypeRegion = _c[1];
    var _d = useState(""), parentRegionId = _d[0], setParentRegionId = _d[1];
    var _e = useState([]), provinceList = _e[0], setProvinceList = _e[1];
    var _f = useState([]), townList = _f[0], setTownList = _f[1];
    var _g = useState([]), sectorList = _g[0], setSectorList = _g[1];
    var _h = useGetRegions(triggerRegion, typeRegion, parentRegionId), responseRegion = _h.responseRegion, errorRegion = _h.errorRegion, loadingRegion = _h.loadingRegion;
    // Inicializar carga de regiones
    useEffect(function () {
        setTriggerRegion(true);
    }, []);
    // Transformar datos de región a formato select
    var transformRegionData = function (regions) {
        return __spreadArray([
            EMPTY_OPTION
        ], regions.map(function (region) { return ({
            id: region.id || "-1",
            value: region.id || "-1",
            name: region.name || " ",
        }); }), true);
    };
    // Procesar respuesta de región
    useEffect(function () {
        if (!(responseRegion === null || responseRegion === void 0 ? void 0 : responseRegion.data))
            return;
        var data = transformRegionData(responseRegion.data);
        var emptyData = [EMPTY_OPTION];
        switch (responseRegion.level) {
            case level1:
                setProvinceList(data);
                // Auto-cargar nivel 2 si hay datos de dirección
                if ((addressData === null || addressData === void 0 ? void 0 : addressData.providence) && townList.length === 0) {
                    setTypeRegion("REGION_LEVEL2");
                    setParentRegionId(addressData.providence);
                }
                break;
            case level2:
                setTownList(data.length > 1 ? data : emptyData);
                // Auto-cargar nivel 3 si hay datos de dirección
                if ((addressData === null || addressData === void 0 ? void 0 : addressData.town) && sectorList.length === 0) {
                    setTypeRegion("REGION_LEVEL3");
                    setParentRegionId(addressData.town);
                }
                break;
            case level3:
                setSectorList(data.length > 1 ? data : emptyData);
                break;
        }
        dispatch(regionClearData());
    }, [responseRegion]);
    // Manejar cambios en selects de región
    var handleRegionChange = function (dataSelect, fieldName) {
        var _a, _b;
        if (fieldName === "Province") {
            setTownList([EMPTY_OPTION]);
            setSectorList([EMPTY_OPTION]);
            setTypeRegion("REGION_LEVEL2");
            setParentRegionId((_a = dataSelect.id) !== null && _a !== void 0 ? _a : "");
        }
        else if (fieldName === "Town") {
            setSectorList([EMPTY_OPTION]);
            setTypeRegion("REGION_LEVEL3");
            setParentRegionId((_b = dataSelect.id) !== null && _b !== void 0 ? _b : "");
        }
    };
    return {
        provinceList: provinceList,
        townList: townList,
        sectorList: sectorList,
        handleRegionChange: handleRegionChange,
        loadingRegion: loadingRegion,
        errorRegion: errorRegion,
        EMPTY_OPTION: EMPTY_OPTION,
    };
};
